module.exports = __webpack_public_path__ + "media/mediaProfessionals/curved-line-b2384289.png";